import { IdAndName } from 'src/service/view-model/base/IdAndName'
import { findReferenceObject } from 'src/service/view-model/base/Reference.utils'
import { REGION_ASIA, REGION_EU, REGION_US } from 'src/user/Regions'

export interface TimezoneObject extends IdAndName {
  group: string
}

const group1 = ''
const group2 = REGION_EU.name
const group3 = REGION_US.name
const group4 = REGION_ASIA.name
const group5 = 'countryAutocompleteOther'

// prettier-ignore
export const TIMEZONES: TimezoneObject[] = [
  { id: 'Europe/Zurich', name: 'Zurich (UTC+01:00)', group: group1 },
  { id: 'Europe/Berlin', name: 'Berlin (UTC+01:00)', group: group1 },
  { id: 'Europe/Vienna', name: 'Vienna (UTC+01:00)', group: group1 },
  { id: 'Europe/London', name: 'London (UTC+00:00)', group: group1 },

  { id: 'Europe/Amsterdam', name: 'Europe / Amsterdam (UTC+01:00)', group: group2 },
  { id: 'Europe/Andorra', name: 'Europe / Andorra (UTC+01:00)', group: group2 },
  { id: 'Europe/Athens', name: 'Europe / Athens (UTC+02:00)', group: group2 },
  { id: 'Europe/Belfast', name: 'Europe / Belfast (UTC+00:00)', group: group2 },
  { id: 'Europe/Belgrade', name: 'Europe / Belgrade (UTC+01:00)', group: group2 },
  { id: 'Europe/Bratislava', name: 'Europe / Bratislava (UTC+01:00)', group: group2 },
  { id: 'Europe/Brussels', name: 'Europe / Brussels (UTC+01:00)', group: group2 },
  { id: 'Europe/Bucharest', name: 'Europe / Bucharest (UTC+02:00)', group: group2 },
  { id: 'Europe/Budapest', name: 'Europe / Budapest (UTC+01:00)', group: group2 },
  { id: 'Europe/Chisinau', name: 'Europe / Chisinau (UTC+02:00)', group: group2 },
  { id: 'Europe/Copenhagen', name: 'Europe / Copenhagen (UTC+01:00)', group: group2 },
  { id: 'Europe/Dublin', name: 'Europe / Dublin (UTC+00:00)', group: group2 },
  { id: 'Europe/Gibraltar', name: 'Europe / Gibraltar (UTC+01:00)', group: group2 },
  { id: 'Europe/Guernsey', name: 'Europe / Guernsey (UTC+00:00)', group: group2 },
  { id: 'Europe/Helsinki', name: 'Europe / Helsinki (UTC+02:00)', group: group2 },
  { id: 'Europe/Isle_of_Man', name: 'Europe / Isle_of_Man (UTC+00:00)', group: group2 },
  { id: 'Europe/Istanbul', name: 'Europe / Istanbul (UTC+03:00)', group: group2 },
  { id: 'Europe/Jersey', name: 'Europe / Jersey (UTC+00:00)', group: group2 },
  { id: 'Europe/Kaliningrad', name: 'Europe / Kaliningrad (UTC+02:00)', group: group2 },
  { id: 'Europe/Kiev', name: 'Europe / Kiev (UTC+02:00)', group: group2 },
  { id: 'Europe/Lisbon', name: 'Europe / Lisbon (UTC+00:00)', group: group2 },
  { id: 'Europe/Ljubljana', name: 'Europe / Ljubljana (UTC+01:00)', group: group2 },
  { id: 'Europe/Luxembourg', name: 'Europe / Luxembourg (UTC+01:00)', group: group2 },
  { id: 'Europe/Madrid', name: 'Europe / Madrid (UTC+01:00)', group: group2 },
  { id: 'Europe/Malta', name: 'Europe / Malta (UTC+01:00)', group: group2 },
  { id: 'Europe/Mariehamn', name: 'Europe / Mariehamn (UTC+02:00)', group: group2 },
  { id: 'Europe/Minsk', name: 'Europe / Minsk (UTC+03:00)', group: group2 },
  { id: 'Europe/Monaco', name: 'Europe / Monaco (UTC+01:00)', group: group2 },
  { id: 'Europe/Moscow', name: 'Europe / Moscow (UTC+03:00)', group: group2 },
  { id: 'Europe/Nicosia', name: 'Europe / Nicosia (UTC+02:00)', group: group2 },
  { id: 'Europe/Oslo', name: 'Europe / Oslo (UTC+01:00)', group: group2 },
  { id: 'Europe/Paris', name: 'Europe / Paris (UTC+01:00)', group: group2 },
  { id: 'Europe/Podgorica', name: 'Europe / Podgorica (UTC+01:00)', group: group2 },
  { id: 'Europe/Prague', name: 'Europe / Prague (UTC+01:00)', group: group2 },
  { id: 'Europe/Riga', name: 'Europe / Riga (UTC+02:00)', group: group2 },
  { id: 'Europe/Rome', name: 'Europe / Rome (UTC+01:00)', group: group2 },
  { id: 'Europe/Samara', name: 'Europe / Samara (UTC+04:00)', group: group2 },
  { id: 'Europe/San_Marino', name: 'Europe / San_Marino (UTC+01:00)', group: group2 },
  { id: 'Europe/Sarajevo', name: 'Europe / Sarajevo (UTC+01:00)', group: group2 },
  { id: 'Europe/Simferopol', name: 'Europe / Simferopol (UTC+03:00)', group: group2 },
  { id: 'Europe/Skopje', name: 'Europe / Skopje (UTC+01:00)', group: group2 },
  { id: 'Europe/Sofia', name: 'Europe / Sofia (UTC+02:00)', group: group2 },
  { id: 'Europe/Stockholm', name: 'Europe / Stockholm (UTC+01:00)', group: group2 },
  { id: 'Europe/Tallinn', name: 'Europe / Tallinn (UTC+02:00)', group: group2 },
  { id: 'Europe/Tirane', name: 'Europe / Tirane (UTC+01:00)', group: group2 },
  { id: 'Europe/Tiraspol', name: 'Europe / Tiraspol (UTC+02:00)', group: group2 },
  { id: 'Europe/Uzhgorod', name: 'Europe / Uzhgorod (UTC+02:00)', group: group2 },
  { id: 'Europe/Vaduz', name: 'Europe / Vaduz (UTC+01:00)', group: group2 },
  { id: 'Europe/Vatican', name: 'Europe / Vatican (UTC+01:00)', group: group2 },
  { id: 'Europe/Vilnius', name: 'Europe / Vilnius (UTC+02:00)', group: group2 },
  { id: 'Europe/Volgograd', name: 'Europe / Volgograd (UTC+03:00)', group: group2 },
  { id: 'Europe/Warsaw', name: 'Europe / Warsaw (UTC+01:00)', group: group2 },
  { id: 'Europe/Zagreb', name: 'Europe / Zagreb (UTC+01:00)', group: group2 },
  { id: 'Europe/Zaporozhye', name: 'Europe / Zaporozhye (UTC+02:00)', group: group2 },

  { id: 'America/Adak', name: 'America / Adak (UTC-10:00)', group: group3 },
  { id: 'America/Anchorage', name: 'America / Anchorage (UTC-09:00)', group: group3 },
  { id: 'America/Anguilla', name: 'America / Anguilla (UTC-04:00)', group: group3 },
  { id: 'America/Antigua', name: 'America / Antigua (UTC-04:00)', group: group3 },
  { id: 'America/Araguaina', name: 'America / Araguaina (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / Buenos_Aires', name: 'America / Argentina / Buenos_Aires (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / Catamarca', name: 'America / Argentina / Catamarca (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / ComodRivadavia', name: 'America / Argentina / ComodRivadavia (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / Cordoba', name: 'America / Argentina / Cordoba (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / Jujuy', name: 'America / Argentina / Jujuy (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / La_Rioja', name: 'America / Argentina / La_Rioja (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / Mendoza', name: 'America / Argentina / Mendoza (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / Rio_Gallegos', name: 'America / Argentina / Rio_Gallegos (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / Salta', name: 'America / Argentina / Salta (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / San_Juan', name: 'America / Argentina / San_Juan (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / San_Luis', name: 'America / Argentina / San_Luis (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / Tucuman', name: 'America / Argentina / Tucuman (UTC-03:00)', group: group3 },
  { id: 'America/Argentina / Ushuaia', name: 'America / Argentina / Ushuaia (UTC-03:00)', group: group3 },
  { id: 'America/Aruba', name: 'America / Aruba (UTC-04:00)', group: group3 },
  { id: 'America/Asuncion', name: 'America / Asuncion (UTC-04:00)', group: group3 },
  { id: 'America/Atikokan', name: 'America / Atikokan (UTC-05:00)', group: group3 },
  { id: 'America/Atka', name: 'America / Atka (UTC-10:00)', group: group3 },
  { id: 'America/Bahia', name: 'America / Bahia (UTC-03:00)', group: group3 },
  { id: 'America/Barbados', name: 'America / Barbados (UTC-04:00)', group: group3 },
  { id: 'America/Belem', name: 'America / Belem (UTC-03:00)', group: group3 },
  { id: 'America/Belize', name: 'America / Belize (UTC-06:00)', group: group3 },
  { id: 'America/Blanc - Sablon', name: 'America / Blanc - Sablon (UTC-04:00)', group: group3 },
  { id: 'America/Boa_Vista', name: 'America / Boa_Vista (UTC-04:00)', group: group3 },
  { id: 'America/Bogota', name: 'America / Bogota (UTC-05:00)', group: group3 },
  { id: 'America/Boise', name: 'America / Boise (UTC-07:00)', group: group3 },
  { id: 'America/Buenos_Aires', name: 'America / Buenos_Aires (UTC-03:00)', group: group3 },
  { id: 'America/Cambridge_Bay', name: 'America / Cambridge_Bay (UTC-07:00)', group: group3 },
  { id: 'America/Campo_Grande', name: 'America / Campo_Grande (UTC-04:00)', group: group3 },
  { id: 'America/Cancun', name: 'America / Cancun (UTC-05:00)', group: group3 },
  { id: 'America/Caracas', name: 'America / Caracas (UTC-04:00)', group: group3 },
  { id: 'America/Catamarca', name: 'America / Catamarca (UTC-03:00)', group: group3 },
  { id: 'America/Cayenne', name: 'America / Cayenne (UTC-03:00)', group: group3 },
  { id: 'America/Cayman', name: 'America / Cayman (UTC-05:00)', group: group3 },
  { id: 'America/Chicago', name: 'America / Chicago (UTC-06:00)', group: group3 },
  { id: 'America/Chihuahua', name: 'America / Chihuahua (UTC-07:00)', group: group3 },
  { id: 'America/Coral_Harbour', name: 'America / Coral_Harbour (UTC-05:00)', group: group3 },
  { id: 'America/Cordoba', name: 'America / Cordoba (UTC-03:00)', group: group3 },
  { id: 'America/Costa_Rica', name: 'America / Costa_Rica (UTC-06:00)', group: group3 },
  { id: 'America/Cuiaba', name: 'America / Cuiaba (UTC-04:00)', group: group3 },
  { id: 'America/Curacao', name: 'America / Curacao (UTC-04:00)', group: group3 },
  { id: 'America/Danmarkshavn', name: 'America / Danmarkshavn (UTC+00:00)', group: group3 },
  { id: 'America/Dawson', name: 'America / Dawson (UTC-08:00)', group: group3 },
  { id: 'America/Dawson_Creek', name: 'America / Dawson_Creek (UTC-07:00)', group: group3 },
  { id: 'America/Denver', name: 'America / Denver (UTC-07:00)', group: group3 },
  { id: 'America/Detroit', name: 'America / Detroit (UTC-05:00)', group: group3 },
  { id: 'America/Dominica', name: 'America / Dominica (UTC-04:00)', group: group3 },
  { id: 'America/Edmonton', name: 'America / Edmonton (UTC-07:00)', group: group3 },
  { id: 'America/Eirunepe', name: 'America / Eirunepe (UTC-05:00)', group: group3 },
  { id: 'America/El_Salvador', name: 'America / El_Salvador (UTC-06:00)', group: group3 },
  { id: 'America/Ensenada', name: 'America / Ensenada (UTC-08:00)', group: group3 },
  { id: 'America/Fortaleza', name: 'America / Fortaleza (UTC-03:00)', group: group3 },
  { id: 'America/Fort_Wayne', name: 'America / Fort_Wayne (UTC-05:00)', group: group3 },
  { id: 'America/Glace_Bay', name: 'America / Glace_Bay (UTC-04:00)', group: group3 },
  { id: 'America/Godthab', name: 'America / Godthab (UTC-03:00)', group: group3 },
  { id: 'America/Goose_Bay', name: 'America / Goose_Bay (UTC-04:00)', group: group3 },
  { id: 'America/Grand_Turk', name: 'America / Grand_Turk (UTC-05:00)', group: group3 },
  { id: 'America/Grenada', name: 'America / Grenada (UTC-04:00)', group: group3 },
  { id: 'America/Guadeloupe', name: 'America / Guadeloupe (UTC-04:00)', group: group3 },
  { id: 'America/Guatemala', name: 'America / Guatemala (UTC-06:00)', group: group3 },
  { id: 'America/Guayaquil', name: 'America / Guayaquil (UTC-05:00)', group: group3 },
  { id: 'America/Guyana', name: 'America / Guyana (UTC-04:00)', group: group3 },
  { id: 'America/Halifax', name: 'America / Halifax (UTC-04:00)', group: group3 },
  { id: 'America/Havana', name: 'America / Havana (UTC-05:00)', group: group3 },
  { id: 'America/Hermosillo', name: 'America / Hermosillo (UTC-07:00)', group: group3 },
  { id: 'America/Indiana / Indianapolis', name: 'America / Indiana / Indianapolis (UTC-05:00)', group: group3 },
  { id: 'America/Indiana / Knox', name: 'America / Indiana / Knox (UTC-06:00)', group: group3 },
  { id: 'America/Indiana / Marengo', name: 'America / Indiana / Marengo (UTC-05:00)', group: group3 },
  { id: 'America/Indiana / Petersburg', name: 'America / Indiana / Petersburg (UTC-05:00)', group: group3 },
  { id: 'America/Indiana / Tell_City', name: 'America / Indiana / Tell_City (UTC-06:00)', group: group3 },
  { id: 'America/Indiana / Vevay', name: 'America / Indiana / Vevay (UTC-05:00)', group: group3 },
  { id: 'America/Indiana / Vincennes', name: 'America / Indiana / Vincennes (UTC-05:00)', group: group3 },
  { id: 'America/Indiana / Winamac', name: 'America / Indiana / Winamac (UTC-05:00)', group: group3 },
  { id: 'America/Indianapolis', name: 'America / Indianapolis (UTC-05:00)', group: group3 },
  { id: 'America/Inuvik', name: 'America / Inuvik (UTC-07:00)', group: group3 },
  { id: 'America/Iqaluit', name: 'America / Iqaluit (UTC-05:00)', group: group3 },
  { id: 'America/Jamaica', name: 'America / Jamaica (UTC-05:00)', group: group3 },
  { id: 'America/Jujuy', name: 'America / Jujuy (UTC-03:00)', group: group3 },
  { id: 'America/Juneau', name: 'America / Juneau (UTC-09:00)', group: group3 },
  { id: 'America/Kentucky / Louisville', name: 'America / Kentucky / Louisville (UTC-05:00)', group: group3 },
  { id: 'America/Kentucky / Monticello', name: 'America / Kentucky / Monticello (UTC-05:00)', group: group3 },
  { id: 'America/Knox_IN', name: 'America / Knox_IN (UTC-06:00)', group: group3 },
  { id: 'America/La_Paz', name: 'America / La_Paz (UTC-04:00)', group: group3 },
  { id: 'America/Lima', name: 'America / Lima (UTC-05:00)', group: group3 },
  { id: 'America/Los_Angeles', name: 'America / Los_Angeles (UTC-08:00)', group: group3 },
  { id: 'America/Louisville', name: 'America / Louisville (UTC-05:00)', group: group3 },
  { id: 'America/Maceio', name: 'America / Maceio (UTC-03:00)', group: group3 },
  { id: 'America/Managua', name: 'America / Managua (UTC-06:00)', group: group3 },
  { id: 'America/Manaus', name: 'America / Manaus (UTC-04:00)', group: group3 },
  { id: 'America/Marigot', name: 'America / Marigot (UTC-04:00)', group: group3 },
  { id: 'America/Martinique', name: 'America / Martinique (UTC-04:00)', group: group3 },
  { id: 'America/Matamoros', name: 'America / Matamoros (UTC-06:00)', group: group3 },
  { id: 'America/Mazatlan', name: 'America / Mazatlan (UTC-07:00)', group: group3 },
  { id: 'America/Mendoza', name: 'America / Mendoza (UTC-03:00)', group: group3 },
  { id: 'America/Menominee', name: 'America / Menominee (UTC-06:00)', group: group3 },
  { id: 'America/Merida', name: 'America / Merida (UTC-06:00)', group: group3 },
  { id: 'America/Mexico_City', name: 'America / Mexico_City (UTC-06:00)', group: group3 },
  { id: 'America/Miquelon', name: 'America / Miquelon (UTC-03:00)', group: group3 },
  { id: 'America/Moncton', name: 'America / Moncton (UTC-04:00)', group: group3 },
  { id: 'America/Monterrey', name: 'America / Monterrey (UTC-06:00)', group: group3 },
  { id: 'America/Montevideo', name: 'America / Montevideo (UTC-03:00)', group: group3 },
  { id: 'America/Montreal', name: 'America / Montreal (UTC-05:00)', group: group3 },
  { id: 'America/Montserrat', name: 'America / Montserrat (UTC-04:00)', group: group3 },
  { id: 'America/Nassau', name: 'America / Nassau (UTC-05:00)', group: group3 },
  { id: 'America/New_York', name: 'America / New_York (UTC-05:00)', group: group3 },
  { id: 'America/Nipigon', name: 'America / Nipigon (UTC-05:00)', group: group3 },
  { id: 'America/Nome', name: 'America / Nome (UTC-09:00)', group: group3 },
  { id: 'America/Noronha', name: 'America / Noronha (UTC-02:00)', group: group3 },
  { id: 'America/North_Dakota / Center', name: 'America / North_Dakota / Center (UTC-06:00)', group: group3 },
  { id: 'America/North_Dakota / New_Salem', name: 'America / North_Dakota / New_Salem (UTC-06:00)', group: group3 },
  { id: 'America/Ojinaga', name: 'America / Ojinaga (UTC-07:00)', group: group3 },
  { id: 'America/Panama', name: 'America / Panama (UTC-05:00)', group: group3 },
  { id: 'America/Pangnirtung', name: 'America / Pangnirtung (UTC-05:00)', group: group3 },
  { id: 'America/Paramaribo', name: 'America / Paramaribo (UTC-03:00)', group: group3 },
  { id: 'America/Phoenix', name: 'America / Phoenix (UTC-07:00)', group: group3 },
  { id: 'America/Port - au - Prince', name: 'America / Port - au - Prince (UTC-05:00)', group: group3 },
  { id: 'America/Porto_Acre', name: 'America / Porto_Acre (UTC-05:00)', group: group3 },
  { id: 'America/Port_of_Spain', name: 'America / Port_of_Spain (UTC-04:00)', group: group3 },
  { id: 'America/Porto_Velho', name: 'America / Porto_Velho (UTC-04:00)', group: group3 },
  { id: 'America/Puerto_Rico', name: 'America / Puerto_Rico (UTC-04:00)', group: group3 },
  { id: 'America/Rainy_River', name: 'America / Rainy_River (UTC-06:00)', group: group3 },
  { id: 'America/Rankin_Inlet', name: 'America / Rankin_Inlet (UTC-06:00)', group: group3 },
  { id: 'America/Recife', name: 'America / Recife (UTC-03:00)', group: group3 },
  { id: 'America/Regina', name: 'America / Regina (UTC-06:00)', group: group3 },
  { id: 'America/Resolute', name: 'America / Resolute (UTC-06:00)', group: group3 },
  { id: 'America/Rio_Branco', name: 'America / Rio_Branco (UTC-05:00)', group: group3 },
  { id: 'America/Rosario', name: 'America / Rosario (UTC-03:00)', group: group3 },
  { id: 'America/Santa_Isabel', name: 'America / Santa_Isabel (UTC-08:00)', group: group3 },
  { id: 'America/Santarem', name: 'America / Santarem (UTC-03:00)', group: group3 },
  { id: 'America/Santiago', name: 'America / Santiago (UTC-04:00)', group: group3 },
  { id: 'America/Santo_Domingo', name: 'America / Santo_Domingo (UTC-04:00)', group: group3 },
  { id: 'America/Sao_Paulo', name: 'America / Sao_Paulo (UTC-03:00)', group: group3 },
  { id: 'America/Scoresbysund', name: 'America / Scoresbysund (UTC-01:00)', group: group3 },
  { id: 'America/Shiprock', name: 'America / Shiprock (UTC-07:00)', group: group3 },
  { id: 'America/St_Barthelemy', name: 'America / St_Barthelemy (UTC-04:00)', group: group3 },
  { id: 'America/St_Johns', name: 'America / St_Johns (UTC-03:30)', group: group3 },
  { id: 'America/St_Kitts', name: 'America / St_Kitts (UTC-04:00)', group: group3 },
  { id: 'America/St_Lucia', name: 'America / St_Lucia (UTC-04:00)', group: group3 },
  { id: 'America/St_Thomas', name: 'America / St_Thomas (UTC-04:00)', group: group3 },
  { id: 'America/St_Vincent', name: 'America / St_Vincent (UTC-04:00)', group: group3 },
  { id: 'America/Swift_Current', name: 'America / Swift_Current (UTC-06:00)', group: group3 },
  { id: 'America/Tegucigalpa', name: 'America / Tegucigalpa (UTC-06:00)', group: group3 },
  { id: 'America/Thule', name: 'America / Thule (UTC-04:00)', group: group3 },
  { id: 'America/Thunder_Bay', name: 'America / Thunder_Bay (UTC-05:00)', group: group3 },
  { id: 'America/Tijuana', name: 'America / Tijuana (UTC-08:00)', group: group3 },
  { id: 'America/Toronto', name: 'America / Toronto (UTC-05:00)', group: group3 },
  { id: 'America/Tortola', name: 'America / Tortola (UTC-04:00)', group: group3 },
  { id: 'America/Vancouver', name: 'America / Vancouver (UTC-08:00)', group: group3 },
  { id: 'America/Virgin', name: 'America / Virgin (UTC-04:00)', group: group3 },
  { id: 'America/Whitehorse', name: 'America / Whitehorse (UTC-08:00)', group: group3 },
  { id: 'America/Winnipeg', name: 'America / Winnipeg (UTC-06:00)', group: group3 },
  { id: 'America/Yakutat', name: 'America / Yakutat (UTC-09:00)', group: group3 },
  { id: 'America/Yellowknife', name: 'America / Yellowknife (UTC-07:00)', group: group3 },

  { id: 'Asia/Aden', name: 'Asia / Aden (UTC+03:00)', group: group4 },
  { id: 'Asia/Almaty', name: 'Asia / Almaty (UTC+05:00)', group: group4 },
  { id: 'Asia/Amman', name: 'Asia / Amman (UTC+02:00)', group: group4 },
  { id: 'Asia/Anadyr', name: 'Asia / Anadyr (UTC+12:00)', group: group4 },
  { id: 'Asia/Aqtau', name: 'Asia / Aqtau (UTC+05:00)', group: group4 },
  { id: 'Asia/Aqtobe', name: 'Asia / Aqtobe (UTC+05:00)', group: group4 },
  { id: 'Asia/Ashgabat', name: 'Asia / Ashgabat (UTC+05:00)', group: group4 },
  { id: 'Asia/Ashkhabad', name: 'Asia / Ashkhabad (UTC+05:00)', group: group4 },
  { id: 'Asia/Baghdad', name: 'Asia / Baghdad (UTC+03:00)', group: group4 },
  { id: 'Asia/Bahrain', name: 'Asia / Bahrain (UTC+03:00)', group: group4 },
  { id: 'Asia/Baku', name: 'Asia / Baku (UTC+04:00)', group: group4 },
  { id: 'Asia/Bangkok', name: 'Asia / Bangkok (UTC+07:00)', group: group4 },
  { id: 'Asia/Beirut', name: 'Asia / Beirut (UTC+02:00)', group: group4 },
  { id: 'Asia/Bishkek', name: 'Asia / Bishkek (UTC+06:00)', group: group4 },
  { id: 'Asia/Brunei', name: 'Asia / Brunei (UTC+08:00)', group: group4 },
  { id: 'Asia/Calcutta', name: 'Asia / Calcutta (UTC+05:30)', group: group4 },
  { id: 'Asia/Choibalsan', name: 'Asia / Choibalsan (UTC+08:00)', group: group4 },
  { id: 'Asia/Chongqing', name: 'Asia / Chongqing (UTC+08:00)', group: group4 },
  { id: 'Asia/Chungking', name: 'Asia / Chungking (UTC+08:00)', group: group4 },
  { id: 'Asia/Colombo', name: 'Asia / Colombo (UTC+05:30)', group: group4 },
  { id: 'Asia/Dacca', name: 'Asia / Dacca (UTC+06:00)', group: group4 },
  { id: 'Asia/Damascus', name: 'Asia / Damascus (UTC+02:00)', group: group4 },
  { id: 'Asia/Dhaka', name: 'Asia / Dhaka (UTC+06:00)', group: group4 },
  { id: 'Asia/Dili', name: 'Asia / Dili (UTC+09:00)', group: group4 },
  { id: 'Asia/Dubai', name: 'Asia / Dubai (UTC+04:00)', group: group4 },
  { id: 'Asia/Dushanbe', name: 'Asia / Dushanbe (UTC+05:00)', group: group4 },
  { id: 'Asia/Gaza', name: 'Asia / Gaza (UTC+02:00)', group: group4 },
  { id: 'Asia/Harbin', name: 'Asia / Harbin (UTC+08:00)', group: group4 },
  { id: 'Asia/Ho_Chi_Minh', name: 'Asia / Ho_Chi_Minh (UTC+07:00)', group: group4 },
  { id: 'Asia/Hong_Kong', name: 'Asia / Hong_Kong (UTC+08:00)', group: group4 },
  { id: 'Asia/Hovd', name: 'Asia / Hovd (UTC+07:00)', group: group4 },
  { id: 'Asia/Irkutsk', name: 'Asia / Irkutsk (UTC+08:00)', group: group4 },
  { id: 'Asia/Istanbul', name: 'Asia / Istanbul (UTC+03:00)', group: group4 },
  { id: 'Asia/Jakarta', name: 'Asia / Jakarta (UTC+07:00)', group: group4 },
  { id: 'Asia/Jayapura', name: 'Asia / Jayapura (UTC+09:00)', group: group4 },
  { id: 'Asia/Jerusalem', name: 'Asia / Jerusalem (UTC+02:00)', group: group4 },
  { id: 'Asia/Kabul', name: 'Asia / Kabul (UTC+04:30)', group: group4 },
  { id: 'Asia/Kamchatka', name: 'Asia / Kamchatka (UTC+12:00)', group: group4 },
  { id: 'Asia/Karachi', name: 'Asia / Karachi (UTC+05:00)', group: group4 },
  { id: 'Asia/Kashgar', name: 'Asia / Kashgar (UTC+06:00)', group: group4 },
  { id: 'Asia/Kathmandu', name: 'Asia / Kathmandu (UTC+05:45)', group: group4 },
  { id: 'Asia/Katmandu', name: 'Asia / Katmandu (UTC+05:45)', group: group4 },
  { id: 'Asia/Kolkata', name: 'Asia / Kolkata (UTC+05:30)', group: group4 },
  { id: 'Asia/Krasnoyarsk', name: 'Asia / Krasnoyarsk (UTC+07:00)', group: group4 },
  { id: 'Asia/Kuala_Lumpur', name: 'Asia / Kuala_Lumpur (UTC+08:00)', group: group4 },
  { id: 'Asia/Kuching', name: 'Asia / Kuching (UTC+08:00)', group: group4 },
  { id: 'Asia/Kuwait', name: 'Asia / Kuwait (UTC+03:00)', group: group4 },
  { id: 'Asia/Macao', name: 'Asia / Macao (UTC+08:00)', group: group4 },
  { id: 'Asia/Macau', name: 'Asia / Macau (UTC+08:00)', group: group4 },
  { id: 'Asia/Magadan', name: 'Asia / Magadan (UTC+11:00)', group: group4 },
  { id: 'Asia/Makassar', name: 'Asia / Makassar (UTC+08:00)', group: group4 },
  { id: 'Asia/Manila', name: 'Asia / Manila (UTC+08:00)', group: group4 },
  { id: 'Asia/Muscat', name: 'Asia / Muscat (UTC+04:00)', group: group4 },
  { id: 'Asia/Nicosia', name: 'Asia / Nicosia (UTC+02:00)', group: group4 },
  { id: 'Asia/Novokuznetsk', name: 'Asia / Novokuznetsk (UTC+07:00)', group: group4 },
  { id: 'Asia/Novosibirsk', name: 'Asia / Novosibirsk (UTC+07:00)', group: group4 },
  { id: 'Asia/Omsk', name: 'Asia / Omsk (UTC+06:00)', group: group4 },
  { id: 'Asia/Oral', name: 'Asia / Oral (UTC+05:00)', group: group4 },
  { id: 'Asia/Phnom_Penh', name: 'Asia / Phnom_Penh (UTC+07:00)', group: group4 },
  { id: 'Asia/Pontianak', name: 'Asia / Pontianak (UTC+07:00)', group: group4 },
  { id: 'Asia/Pyongyang', name: 'Asia / Pyongyang (UTC+09:00)', group: group4 },
  { id: 'Asia/Qatar', name: 'Asia / Qatar (UTC+03:00)', group: group4 },
  { id: 'Asia/Qyzylorda', name: 'Asia / Qyzylorda (UTC+05:00)', group: group4 },
  { id: 'Asia/Rangoon', name: 'Asia / Rangoon (UTC+06:30)', group: group4 },
  { id: 'Asia/Riyadh', name: 'Asia / Riyadh (UTC+03:00)', group: group4 },
  { id: 'Asia/Saigon', name: 'Asia / Saigon (UTC+07:00)', group: group4 },
  { id: 'Asia/Sakhalin', name: 'Asia / Sakhalin (UTC+11:00)', group: group4 },
  { id: 'Asia/Samarkand', name: 'Asia / Samarkand (UTC+05:00)', group: group4 },
  { id: 'Asia/Seoul', name: 'Asia / Seoul (UTC+09:00)', group: group4 },
  { id: 'Asia/Shanghai', name: 'Asia / Shanghai (UTC+08:00)', group: group4 },
  { id: 'Asia/Singapore', name: 'Asia / Singapore (UTC+08:00)', group: group4 },
  { id: 'Asia/Taipei', name: 'Asia / Taipei (UTC+08:00)', group: group4 },
  { id: 'Asia/Tashkent', name: 'Asia / Tashkent (UTC+05:00)', group: group4 },
  { id: 'Asia/Tbilisi', name: 'Asia / Tbilisi (UTC+04:00)', group: group4 },
  { id: 'Asia/Tehran', name: 'Asia / Tehran (UTC+03:30)', group: group4 },
  { id: 'Asia/Tel_Aviv', name: 'Asia / Tel_Aviv (UTC+02:00)', group: group4 },
  { id: 'Asia/Thimbu', name: 'Asia / Thimbu (UTC+06:00)', group: group4 },
  { id: 'Asia/Thimphu', name: 'Asia / Thimphu (UTC+06:00)', group: group4 },
  { id: 'Asia/Tokyo', name: 'Asia / Tokyo (UTC+09:00)', group: group4 },
  { id: 'Asia/Ujung_Pandang', name: 'Asia / Ujung_Pandang (UTC+08:00)', group: group4 },
  { id: 'Asia/Ulaanbaatar', name: 'Asia / Ulaanbaatar (UTC+08:00)', group: group4 },
  { id: 'Asia/Ulan_Bator', name: 'Asia / Ulan_Bator (UTC+08:00)', group: group4 },
  { id: 'Asia/Urumqi', name: 'Asia / Urumqi (UTC+06:00)', group: group4 },
  { id: 'Asia/Vientiane', name: 'Asia / Vientiane (UTC+07:00)', group: group4 },
  { id: 'Asia/Vladivostok', name: 'Asia / Vladivostok (UTC+10:00)', group: group4 },
  { id: 'Asia/Yakutsk', name: 'Asia / Yakutsk (UTC+09:00)', group: group4 },
  { id: 'Asia/Yekaterinburg', name: 'Asia / Yekaterinburg (UTC+05:00)', group: group4 },
  { id: 'Asia/Yerevan', name: 'Asia / Yerevan (UTC+04:00)', group: group4 },

  { id: 'Africa/Abidjan', name: 'Africa / Abidjan (UTC+00:00)', group: group5 },
  { id: 'Africa/Accra', name: 'Africa / Accra (UTC+00:00)', group: group5 },
  { id: 'Africa/Addis_Ababa', name: 'Africa / Addis_Ababa (UTC+03:00)', group: group5 },
  { id: 'Africa/Algiers', name: 'Africa / Algiers (UTC+01:00)', group: group5 },
  { id: 'Africa/Asmara', name: 'Africa / Asmara (UTC+03:00)', group: group5 },
  { id: 'Africa/Asmera', name: 'Africa / Asmera (UTC+03:00)', group: group5 },
  { id: 'Africa/Bamako', name: 'Africa / Bamako (UTC+00:00)', group: group5 },
  { id: 'Africa/Bangui', name: 'Africa / Bangui (UTC+01:00)', group: group5 },
  { id: 'Africa/Banjul', name: 'Africa / Banjul (UTC+00:00)', group: group5 },
  { id: 'Africa/Bissau', name: 'Africa / Bissau (UTC+00:00)', group: group5 },
  { id: 'Africa/Blantyre', name: 'Africa / Blantyre (UTC+02:00)', group: group5 },
  { id: 'Africa/Brazzaville', name: 'Africa / Brazzaville (UTC+01:00)', group: group5 },
  { id: 'Africa/Bujumbura', name: 'Africa / Bujumbura (UTC+02:00)', group: group5 },
  { id: 'Africa/Cairo', name: 'Africa / Cairo (UTC+02:00)', group: group5 },
  { id: 'Africa/Casablanca', name: 'Africa / Casablanca (UTC+00:00)', group: group5 },
  { id: 'Africa/Ceuta', name: 'Africa / Ceuta (UTC+01:00)', group: group5 },
  { id: 'Africa/Conakry', name: 'Africa / Conakry (UTC+00:00)', group: group5 },
  { id: 'Africa/Dakar', name: 'Africa / Dakar (UTC+00:00)', group: group5 },
  { id: 'Africa/Dar_es_Salaam', name: 'Africa / Dar_es_Salaam (UTC+03:00)', group: group5 },
  { id: 'Africa/Djibouti', name: 'Africa / Djibouti (UTC+03:00)', group: group5 },
  { id: 'Africa/Douala', name: 'Africa / Douala (UTC+01:00)', group: group5 },
  { id: 'Africa/El_Aaiun', name: 'Africa / El_Aaiun (UTC+00:00)', group: group5 },
  { id: 'Africa/Freetown', name: 'Africa / Freetown (UTC+00:00)', group: group5 },
  { id: 'Africa/Gaborone', name: 'Africa / Gaborone (UTC+02:00)', group: group5 },
  { id: 'Africa/Harare', name: 'Africa / Harare (UTC+02:00)', group: group5 },
  { id: 'Africa/Johannesburg', name: 'Africa / Johannesburg (UTC+02:00)', group: group5 },
  { id: 'Africa/Kampala', name: 'Africa / Kampala (UTC+03:00)', group: group5 },
  { id: 'Africa/Khartoum', name: 'Africa / Khartoum (UTC+02:00)', group: group5 },
  { id: 'Africa/Kigali', name: 'Africa / Kigali (UTC+02:00)', group: group5 },
  { id: 'Africa/Kinshasa', name: 'Africa / Kinshasa (UTC+01:00)', group: group5 },
  { id: 'Africa/Lagos', name: 'Africa / Lagos (UTC+01:00)', group: group5 },
  { id: 'Africa/Libreville', name: 'Africa / Libreville (UTC+01:00)', group: group5 },
  { id: 'Africa/Lome', name: 'Africa / Lome (UTC+00:00)', group: group5 },
  { id: 'Africa/Luanda', name: 'Africa / Luanda (UTC+01:00)', group: group5 },
  { id: 'Africa/Lubumbashi', name: 'Africa / Lubumbashi (UTC+02:00)', group: group5 },
  { id: 'Africa/Lusaka', name: 'Africa / Lusaka (UTC+02:00)', group: group5 },
  { id: 'Africa/Malabo', name: 'Africa / Malabo (UTC+01:00)', group: group5 },
  { id: 'Africa/Maputo', name: 'Africa / Maputo (UTC+02:00)', group: group5 },
  { id: 'Africa/Maseru', name: 'Africa / Maseru (UTC+02:00)', group: group5 },
  { id: 'Africa/Mbabane', name: 'Africa / Mbabane (UTC+02:00)', group: group5 },
  { id: 'Africa/Mogadishu', name: 'Africa / Mogadishu (UTC+03:00)', group: group5 },
  { id: 'Africa/Monrovia', name: 'Africa / Monrovia (UTC+00:00)', group: group5 },
  { id: 'Africa/Nairobi', name: 'Africa / Nairobi (UTC+03:00)', group: group5 },
  { id: 'Africa/Ndjamena', name: 'Africa / Ndjamena (UTC+01:00)', group: group5 },
  { id: 'Africa/Niamey', name: 'Africa / Niamey (UTC+01:00)', group: group5 },
  { id: 'Africa/Nouakchott', name: 'Africa / Nouakchott (UTC+00:00)', group: group5 },
  { id: 'Africa/Ouagadougou', name: 'Africa / Ouagadougou (UTC+00:00)', group: group5 },
  { id: 'Africa/Porto - Novo', name: 'Africa / Porto - Novo (UTC+01:00)', group: group5 },
  { id: 'Africa/Sao_Tome', name: 'Africa / Sao_Tome (UTC+00:00)', group: group5 },
  { id: 'Africa/Timbuktu', name: 'Africa / Timbuktu (UTC+00:00)', group: group5 },
  { id: 'Africa/Tripoli', name: 'Africa / Tripoli (UTC+02:00)', group: group5 },
  { id: 'Africa/Tunis', name: 'Africa / Tunis (UTC+01:00)', group: group5 },
  { id: 'Africa/Windhoek', name: 'Africa / Windhoek (UTC+02:00)', group: group5 },

  { id: 'Australia / ACT', name: 'Australia / ACT (UTC+10:00)', group: group5 },
  { id: 'Australia / Adelaide', name: 'Australia / Adelaide (UTC+09:30)', group: group5 },
  { id: 'Australia / Brisbane', name: 'Australia / Brisbane (UTC+10:00)', group: group5 },
  { id: 'Australia / Broken_Hill', name: 'Australia / Broken_Hill (UTC+09:30)', group: group5 },
  { id: 'Australia / Canberra', name: 'Australia / Canberra (UTC+10:00)', group: group5 },
  { id: 'Australia / Currie', name: 'Australia / Currie (UTC+10:00)', group: group5 },
  { id: 'Australia / Darwin', name: 'Australia / Darwin (UTC+09:30)', group: group5 },
  { id: 'Australia / Eucla', name: 'Australia / Eucla (UTC+08:45)', group: group5 },
  { id: 'Australia / Hobart', name: 'Australia / Hobart (UTC+10:00)', group: group5 },
  { id: 'Australia / LHI', name: 'Australia / LHI (UTC+10:30)', group: group5 },
  { id: 'Australia / Lindeman', name: 'Australia / Lindeman (UTC+10:00)', group: group5 },
  { id: 'Australia / Lord_Howe', name: 'Australia / Lord_Howe (UTC+10:30)', group: group5 },
  { id: 'Australia / Melbourne', name: 'Australia / Melbourne (UTC+10:00)', group: group5 },
  { id: 'Australia / North', name: 'Australia / North (UTC+09:30)', group: group5 },
  { id: 'Australia / NSW', name: 'Australia / NSW (UTC+10:00)', group: group5 },
  { id: 'Australia / Perth', name: 'Australia / Perth (UTC+08:00)', group: group5 },
  { id: 'Australia / Queensland', name: 'Australia / Queensland (UTC+10:00)', group: group5 },
  { id: 'Australia / South', name: 'Australia / South (UTC+09:30)', group: group5 },
  { id: 'Australia / Sydney', name: 'Australia / Sydney (UTC+10:00)', group: group5 },
  { id: 'Australia / Tasmania', name: 'Australia / Tasmania (UTC+10:00)', group: group5 },
  { id: 'Australia / Victoria', name: 'Australia / Victoria (UTC+10:00)', group: group5 },
  { id: 'Australia / West', name: 'Australia / West (UTC+08:00)', group: group5 },
  { id: 'Australia / Yancowinna', name: 'Australia / Yancowinna (UTC+09:30)', group: group5 },

  { id: 'Indian/Antananarivo', name: 'Indian / Antananarivo (UTC+03:00)', group: group5 },
  { id: 'Indian/Chagos', name: 'Indian / Chagos (UTC+06:00)', group: group5 },
  { id: 'Indian/Christmas', name: 'Indian / Christmas (UTC+07:00)', group: group5 },
  { id: 'Indian/Cocos', name: 'Indian / Cocos (UTC+06:30)', group: group5 },
  { id: 'Indian/Comoro', name: 'Indian / Comoro (UTC+03:00)', group: group5 },
  { id: 'Indian/Kerguelen', name: 'Indian / Kerguelen (UTC+05:00)', group: group5 },
  { id: 'Indian/Mahe', name: 'Indian / Mahe (UTC+04:00)', group: group5 },
  { id: 'Indian/Maldives', name: 'Indian / Maldives (UTC+05:00)', group: group5 },
  { id: 'Indian/Mauritius', name: 'Indian / Mauritius (UTC+04:00)', group: group5 },
  { id: 'Indian/Mayotte', name: 'Indian / Mayotte (UTC+03:00)', group: group5 },
  { id: 'Indian/Reunion', name: 'Indian / Reunion (UTC+04:00)', group: group5 },

  { id: 'Atlantic/Azores', name: 'Atlantic / Azores (UTC-01:00)', group: group5 },
  { id: 'Atlantic/Bermuda', name: 'Atlantic / Bermuda (UTC-04:00)', group: group5 },
  { id: 'Atlantic/Canary', name: 'Atlantic / Canary (UTC+00:00)', group: group5 },
  { id: 'Atlantic/Cape_Verde', name: 'Atlantic / Cape_Verde (UTC-01:00)', group: group5 },
  { id: 'Atlantic/Faeroe', name: 'Atlantic / Faeroe (UTC+00:00)', group: group5 },
  { id: 'Atlantic/Faroe', name: 'Atlantic / Faroe (UTC+00:00)', group: group5 },
  { id: 'Atlantic/Jan_Mayen', name: 'Atlantic / Jan_Mayen (UTC+01:00)', group: group5 },
  { id: 'Atlantic/Madeira', name: 'Atlantic / Madeira (UTC+00:00)', group: group5 },
  { id: 'Atlantic/Reykjavik', name: 'Atlantic / Reykjavik (UTC+00:00)', group: group5 },
  { id: 'Atlantic/South_Georgia', name: 'Atlantic / South_Georgia (UTC-02:00)', group: group5 },
  { id: 'Atlantic/Stanley', name: 'Atlantic / Stanley (UTC-03:00)', group: group5 },
  { id: 'Atlantic/St_Helena', name: 'Atlantic / St_Helena (UTC+00:00)', group: group5 },

  { id: 'Pacific/Apia', name: 'Pacific / Apia (UTC+13:00)', group: group5 },
  { id: 'Pacific/Auckland', name: 'Pacific / Auckland (UTC+12:00)', group: group5 },
  { id: 'Pacific/Chatham', name: 'Pacific / Chatham (UTC+12:45)', group: group5 },
  { id: 'Pacific/Easter', name: 'Pacific / Easter (UTC-06:00)', group: group5 },
  { id: 'Pacific/Efate', name: 'Pacific / Efate (UTC+11:00)', group: group5 },
  { id: 'Pacific/Enderbury', name: 'Pacific / Enderbury (UTC+13:00)', group: group5 },
  { id: 'Pacific/Fakaofo', name: 'Pacific / Fakaofo (UTC+13:00)', group: group5 },
  { id: 'Pacific/Fiji', name: 'Pacific / Fiji (UTC+12:00)', group: group5 },
  { id: 'Pacific/Funafuti', name: 'Pacific / Funafuti (UTC+12:00)', group: group5 },
  { id: 'Pacific/Galapagos', name: 'Pacific / Galapagos (UTC-06:00)', group: group5 },
  { id: 'Pacific/Gambier', name: 'Pacific / Gambier (UTC-09:00)', group: group5 },
  { id: 'Pacific/Guadalcanal', name: 'Pacific / Guadalcanal (UTC+11:00)', group: group5 },
  { id: 'Pacific/Guam', name: 'Pacific / Guam (UTC+10:00)', group: group5 },
  { id: 'Pacific/Honolulu', name: 'Pacific / Honolulu (UTC-10:00)', group: group5 },
  { id: 'Pacific/Johnston', name: 'Pacific / Johnston (UTC-10:00)', group: group5 },
  { id: 'Pacific/Kiritimati', name: 'Pacific / Kiritimati (UTC+14:00)', group: group5 },
  { id: 'Pacific/Kosrae', name: 'Pacific / Kosrae (UTC+11:00)', group: group5 },
  { id: 'Pacific/Kwajalein', name: 'Pacific / Kwajalein (UTC+12:00)', group: group5 },
  { id: 'Pacific/Majuro', name: 'Pacific / Majuro (UTC+12:00)', group: group5 },
  { id: 'Pacific/Marquesas', name: 'Pacific / Marquesas (UTC-09:30)', group: group5 },
  { id: 'Pacific/Midway', name: 'Pacific / Midway (UTC-11:00)', group: group5 },
  { id: 'Pacific/Nauru', name: 'Pacific / Nauru (UTC+12:00)', group: group5 },
  { id: 'Pacific/Niue', name: 'Pacific / Niue (UTC-11:00)', group: group5 },
  { id: 'Pacific/Norfolk', name: 'Pacific / Norfolk (UTC+11:00)', group: group5 },
  { id: 'Pacific/Noumea', name: 'Pacific / Noumea (UTC+11:00)', group: group5 },
  { id: 'Pacific/Pago_Pago', name: 'Pacific / Pago_Pago (UTC-11:00)', group: group5 },
  { id: 'Pacific/Palau', name: 'Pacific / Palau (UTC+09:00)', group: group5 },
  { id: 'Pacific/Pitcairn', name: 'Pacific / Pitcairn (UTC-08:00)', group: group5 },
  { id: 'Pacific/Ponape', name: 'Pacific / Ponape (UTC+11:00)', group: group5 },
  { id: 'Pacific/Port_Moresby', name: 'Pacific / Port_Moresby (UTC+10:00)', group: group5 },
  { id: 'Pacific/Rarotonga', name: 'Pacific / Rarotonga (UTC-10:00)', group: group5 },
  { id: 'Pacific/Saipan', name: 'Pacific / Saipan (UTC+10:00)', group: group5 },
  { id: 'Pacific/Samoa', name: 'Pacific / Samoa (UTC-11:00)', group: group5 },
  { id: 'Pacific/Tahiti', name: 'Pacific / Tahiti (UTC-10:00)', group: group5 },
  { id: 'Pacific/Tarawa', name: 'Pacific / Tarawa (UTC+12:00)', group: group5 },
  { id: 'Pacific/Tongatapu', name: 'Pacific / Tongatapu (UTC+13:00)', group: group5 },
  { id: 'Pacific/Truk', name: 'Pacific / Truk (UTC+10:00)', group: group5 },
  { id: 'Pacific/Wake', name: 'Pacific / Wake (UTC+12:00)', group: group5 },
  { id: 'Pacific/Wallis', name: 'Pacific / Wallis (UTC+12:00)', group: group5 },
  { id: 'Pacific/Yap', name: 'Pacific / Yap (UTC+10:00)', group: group5 },

  { id: 'Antarctica/Casey', name: 'Antarctica / Casey (UTC+08:00)', group: group5 },
  { id: 'Antarctica/Davis', name: 'Antarctica / Davis (UTC+07:00)', group: group5 },
  { id: 'Antarctica/DumontDUrville', name: 'Antarctica / DumontDUrville (UTC+10:00)', group: group5 },
  { id: 'Antarctica/Macquarie', name: 'Antarctica / Macquarie (UTC+11:00)', group: group5 },
  { id: 'Antarctica/Mawson', name: 'Antarctica / Mawson (UTC+05:00)', group: group5 },
  { id: 'Antarctica/McMurdo', name: 'Antarctica / McMurdo (UTC+12:00)', group: group5 },
  { id: 'Antarctica/Palmer', name: 'Antarctica / Palmer (UTC-03:00)', group: group5 },
  { id: 'Antarctica/Rothera', name: 'Antarctica / Rothera (UTC-03:00)', group: group5 },
  { id: 'Antarctica/South_Pole', name: 'Antarctica / South_Pole (UTC+12:00)', group: group5 },
  { id: 'Antarctica/Syowa', name: 'Antarctica / Syowa (UTC+03:00)', group: group5 },
  { id: 'Antarctica/Vostok', name: 'Antarctica / Vostok (UTC+06:00)', group: group5 },

  { id: 'Arctic/Longyearbyen', name: 'Arctic / Longyearbyen (UTC+01:00)', group: group5 },
]

export const getTimezoneObject = (timezoneCode: string | undefined): TimezoneObject | undefined => {
  return findReferenceObject(TIMEZONES, timezoneCode, 'id')
}
